var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Redesign-scoped markdown renderer for notification content. The legacy MARKDOWN_COMPONENTS
// (src/client/util/markdown.tsx) styles links/borders with legacy tokens (text-link, border-dark-1),
// so this is a fresh map on the redesign palette. New component, legacy one untouched (A/B).
export const NOTIFICATION_MARKDOWN_COMPONENTS = {
    p: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<p {...props} className="my-1 first:mt-0 last:mb-0">{props.children}</p>);
    },
    a: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<a {...props} href={props.href} target="_blank" rel="noopener noreferrer" className="font-medium text-neon-cyan underline underline-offset-2 transition-opacity hover:opacity-80">
			{props.children}
		</a>);
    },
    strong: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<strong {...props} className="font-semibold text-foreground">{props.children}</strong>);
    },
    ul: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<ul {...props} className="my-1 list-inside list-disc space-y-0.5">{props.children}</ul>);
    },
    ol: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<ol {...props} className="my-1 list-inside list-decimal space-y-0.5">{props.children}</ol>);
    },
    h1: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<span {...props} className="font-display text-sm font-semibold text-foreground">{props.children}</span>);
    },
    h2: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<span {...props} className="font-display text-sm font-semibold text-foreground">{props.children}</span>);
    },
    h3: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<span {...props} className="font-display text-sm font-semibold text-foreground">{props.children}</span>);
    },
    hr: (_a) => {
        var { node } = _a, props = __rest(_a, ["node"]);
        return (<hr {...props} className="my-2 border-t border-solid border-border"/>);
    },
};
